// extracted by mini-css-extract-plugin
module.exports = {"castContainer":"styles_castContainer__3VQQZ","castTitle":"styles_castTitle__jFkjm"};